import { brandingConfig, type BrandConfig } from '@/config/branding'

/** Product logo — not CRM/partner white-label (see processors.json `tagadapayRouter`). */
const TAGADAPAY_PROCESSOR_LOGO = '/integrations/tagadapay-logo.png'

const isTagadaPayProcessorType = (type: string): boolean => {
  const normalized = type.toLowerCase()
  return normalized === 'tagadapay' || normalized === 'tagadapay-router'
}

export const getIntegrationImage = (
  type: string,
  brand?: Pick<BrandConfig, 'defaultIntegrationLogo' | 'logo'>,
): string => {
    if (isTagadaPayProcessorType(type)) {
      return TAGADAPAY_PROCESSOR_LOGO
    }

    const brandFallback = brand?.defaultIntegrationLogo ?? brand?.logo ?? brandingConfig.defaultIntegrationLogo ?? brandingConfig.logo

    const integrationImages: Record<string, string> = {
        'stripe': '/integrations/stripe-icon.svg',
        'nmi': '/integrations/nmi-icon.png',
        'netvalve': '/integrations/netvalve-icon.svg',
        'xoala': '/integrations/xoala-icon.svg',
        'unlimit': '/integrations/unlimit-icon.svg',
        'airwallex': '/integrations/airwallex-icon.svg',
        'paypal': '/integrations/paypal.svg',
        'klarna': '/integrations/klarna.svg',
        'bridge': '/integrations/bridge-icon.svg',
        'network-ngenius': '/integrations/network-ngenius-icon.png',
        'ngenius': '/integrations/network-ngenius-icon.png',
        'ccavenue': '/integrations/ccavenue-logo.png',
        'kesspay': '/integrations/kesspay-icon.png',
        'ovri': '/integrations/ovri-icon.png',
        'trustflow': '/integrations/trustflow.png',
        'finix': '/integrations/finix-icon.jpg',
        'chargeblast': '/integrations/chargeblast.png',
        'rcvr': '/integrations/rcvr.jpeg',
        'xcaliber': '/integrations/xcaliber.png',
        'oceanpayment': '/integrations/oceanpayment.svg',
        'converge': '/integrations/converge.jpg',
        'convesiopay': '/integrations/convesiopay.svg',
        'convesio': '/integrations/convesiopay.svg',
        'hipay': '/integrations/hipay.svg',
        'apple-pay': '/integrations/apple-pay.svg',
        'google-pay': '/integrations/google-pay.svg',
        'mastercard': '/integrations/mastercard.svg',
        'shopify': '/integrations/shopify-icon.svg',
        'woocommerce': '/integrations/woo-icon.svg',
        'checkout': '/integrations/checkout-icon.svg',
        'tagadapay': TAGADAPAY_PROCESSOR_LOGO,
        'tagadapay-router': TAGADAPAY_PROCESSOR_LOGO,
        'efipayments': '/integrations/efipayments-logo.png',
        'merchantscale': '/integrations/merchantscale-logo.png',
        'bakolapay': '/integrations/bakolapay-logo.jpeg',
        'authorizenet': '/integrations/authorizenet-icon.png',
        'tap': '/integrations/tap-icon.svg',
        'sandbox': brandFallback,
        'crypto': brandFallback,
        'crypto_onchain': brandFallback,
    }

    return integrationImages[type.toLowerCase()] || brandFallback
}